import { usePortalQuery } from 'src/Libs/api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { fetchChargingSessionsTotalElements } from '../api/charging-sessions-total-elements.api'

interface UseFetchChargingSessionsTotalElementsHook {
  hadChargedAtLeastOnceInThePast: boolean
  isLoading: boolean
  isError: boolean
}

interface UseFetchChargingSessionsTotalElementsParams {
  installationId: number | undefined
  isInstallationDeleted?: boolean
}

/**
 * Used to fetch total elements charging sessions of a single installation.
 * This hook is used to determine if e-mob sidebar item should be disabled if there are no sessions
 *
 * @param installationId - number
 * @param isInstallationDeleted - boolean
 * @returns hadChargedAtLeastOnceInThePast as boolean, isError as boolean, isLoading as boolean
 */

export const useFetchChargingSessionsTotalElements = (
  params: UseFetchChargingSessionsTotalElementsParams
): UseFetchChargingSessionsTotalElementsHook => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isError, isLoading } = usePortalQuery({
    queryFn: () => fetchChargingSessionsTotalElements(params.installationId, authFetch),
    queryKey: ['chargingSessionsTotalElements', params.installationId],
    enabled: Boolean(params.installationId) && !params.isInstallationDeleted,
    select: data => {
      if (!data) {
        return false
      }

      const totalElements = data.page ? data.page.totalElements : data.totalElements

      return totalElements > 0
    },
  })

  return {
    hadChargedAtLeastOnceInThePast: data ?? false,
    isError: isError,
    isLoading: isLoading,
  }
}
